(function () {
  function apply() {
    // 1) 背景Slideshowを探す（ページ種別に依存しない）
    var slideshow = document.querySelector('.slideshow.banner');
    if (!slideshow) return;

    // Slideshowを含む shopify-section
    var slideshowSection = slideshow.closest('.shopify-section');
    if (!slideshowSection) return;

    // 2) 重ねたいFV（data属性で確実に拾う）
    var hero = document.querySelector('[data-hero-overlay="toba"]');
    if (!hero) return;

    // hero を含む shopify-section（これを持ち上げる）
    var heroSection = hero.closest('.shopify-section');
    if (!heroSection) return;

    // 3) Slideshow のテキスト箱（空でも出る）を消す
    var textWrapper = slideshowSection.querySelector('.slideshow__text-wrapper');
    if (textWrapper) textWrapper.style.display = 'none';

    // 4) Slideshow の高さを取って、heroSection を引き上げる
    var h = Math.round(slideshow.getBoundingClientRect().height);
    if (!h || h < 200) return;

    slideshowSection.style.position = 'relative';
    slideshowSection.style.zIndex = '0';

    heroSection.style.position = 'relative';
    heroSection.style.zIndex = '10';
    heroSection.style.marginTop = (-h) + 'px';

    // 5) Hero側の外背景は透明（スライドショー背景を見せる）
    hero.style.background = 'transparent';
  }

  function boot() {
    apply();
    // 画像読み込みで高さが変わるので再適用
    setTimeout(apply, 200);
    setTimeout(apply, 800);
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('resize', apply);

  // テーマエディタの再描画対策
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:section:select', boot);
})();

